export default __webpack_public_path__ + "2edfa47281d11729cf7d8bfd6956cc85.png";